module.exports = __webpack_public_path__ + "img/17.66415b8.svg";